(function () {
  "use strict";
  var CONFIG = { flavourTags: ['fruity','menthol','dessert','drinks','sweets','mint','coffee','tobacco','spicesnutsherbs'], nicotineTags: ['nicsalt','freebase','nicotinefree'], fallbackFlavourTag: 'bestsellers', fallbackNicotineTag: 'nicsalt', productsPerCard: 4, relatedCollectionsCount: 4 };
  var STATIC_TAG_LABELS = { nicsalt:'Nic Salts', freebase:'Freebase', nicotinefree:'Nicotine Free', beginner:'Beginner Friendly', cooling:'Cooling', premium:'Premium', value:'Great Value', bestsellers:'Best Sellers', newflavours:'New Flavours' };
  var STATIC_TAG_ICONS = { fruity:'🍓', menthol:'❄️', dessert:'🍰', drinks:'🥤', sweets:'🍬', mint:'🍃', coffee:'☕', tobacco:'🍂', spicesnutsherbs:'🌿', nicsalt:'💤', freebase:'☁️', nicotinefree:'💧', beginner:'🔰', cooling:'❄️', premium:'💎', value:'💰', bestsellers:'⭐', newflavours:'🆕' };

  function parseScoring(str) {
    if (!str) return [];
    return str.split(',').map(function (part) {
      var bits = part.split(':');
      var tag = (bits[0] || '').trim().toLowerCase();
      var weight = parseFloat(bits[1]);
      if (!tag || isNaN(weight)) return null;
      return { tag: tag, weight: weight };
    }).filter(Boolean);
  }

  function shuffleArray(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr;
  }

  function initQuiz(root) {
    if (!root || root.dataset.ipvqInitialized === 'true') return;
    root.dataset.ipvqInitialized = 'true';
    var sourceEl = root.querySelector('[data-ipvq-source]');
    var tagData = {};
    try { tagData = JSON.parse(sourceEl.textContent || '{}'); } catch (e) { tagData = {}; }

    var settings = {
      matchMin: parseFloat(root.dataset.matchMin || '65'), matchMax: parseFloat(root.dataset.matchMax || '99'),
      beginnerThreshold: parseFloat(root.dataset.beginnerThreshold || '40'), loadingDuration: parseFloat(root.dataset.loadingDuration || '2') * 1000,
      addToCartText: root.dataset.addToCartText || 'Add to Cart', addedText: root.dataset.addedText || 'Added', soldOutText: root.dataset.soldOutText || 'Sold out',
      shopCollectionTemplate: root.dataset.shopCollectionText || 'Shop {name}', progressTemplate: root.dataset.progressLabel || 'Question {current} of {total}',
      remainingTemplate: root.dataset.remainingLabel || 'Only {remaining} left', almostThere: root.dataset.almostThere || 'Almost there!',
      counterTemplate: root.dataset.counterLabel || '{count} of {max} selected', fallbackShopUrl: root.dataset.fallbackShopUrl || '/collections/all'
    };

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ipvq-panel]'));
    var questionPanels = panels.filter(function (p) { return /^q\d$/.test(p.dataset.ipvqPanel); });
    var totalQuestions = questionPanels.length;
    var liveRegion = root.querySelector('[data-ipvq-live]');
    var state = { currentIndex: -1, answers: {} };

    function announce(msg) { if (liveRegion) liveRegion.textContent = msg; }
    function panelByName(name) { return panels.filter(function (p) { return p.dataset.ipvqPanel === name; })[0]; }
    function showPanel(name) {
      panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.ipvqPanel === name); });
      var active = panelByName(name);
      if (active) {
        var heading = active.querySelector('.ipvq__heading');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: false }); }
        active.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    function goToStep(index) {
      if (index === 'analysing') { showPanel('analysing'); runAnalysing(); return; }
      if (index === 'results') { showPanel('results'); return; }
      if (index === -1) { state.currentIndex = -1; showPanel('welcome'); return; }
      state.currentIndex = index;
      var panel = questionPanels[index];
      showPanel(panel.dataset.ipvqPanel);
      updateProgress(panel, index);
      updateNextState(panel);
    }
    function updateProgress(panel, index) {
      var current = index + 1;
      var remaining = totalQuestions - current;
      var progressLabel = panel.querySelector('[data-ipvq-progress-label]');
      var remainingLabel = panel.querySelector('[data-ipvq-remaining-label]');
      var fill = panel.querySelector('[data-ipvq-progress-fill]');
      if (progressLabel) progressLabel.textContent = settings.progressTemplate.replace('{current}', current).replace('{total}', totalQuestions);
      if (remainingLabel) remainingLabel.textContent = remaining <= 0 ? settings.almostThere : settings.remainingTemplate.replace('{remaining}', remaining);
      if (fill) fill.style.width = Math.round((current / totalQuestions) * 100) + '%';
    }
    function updateCounter(panel) {
      var counter = panel.querySelector('[data-ipvq-counter]');
      if (!counter) return;
      var max = parseInt(counter.dataset.max, 10) || 1;
      var count = (state.answers[panel.dataset.ipvqPanel] || []).length;
      counter.textContent = settings.counterTemplate.replace('{count}', count).replace('{max}', max);
    }
    function updateNextState(panel) {
      var nextBtn = panel.querySelector('[data-ipvq-next]');
      if (!nextBtn) return;
      var count = (state.answers[panel.dataset.ipvqPanel] || []).length;
      nextBtn.disabled = count < 1;
    }
    function optionPayload(btn) { return { el: btn, label: btn.dataset.label || '', reason: btn.dataset.reason || '', tags: parseScoring(btn.dataset.tags) }; }
    // Shuffle the visual order of a panel's answer options (excluding any
    // "not sure" style options, which stay pinned at the end). This stops
    // whichever option happens to sit first in the theme editor's block
    // order (e.g. "Fruity") from always being the first thing a shopper
    // sees/clicks — a big source of skew on Q1, where up to 3 picks tie on
    // score and position is otherwise the only thing that decides the winner.
    function randomizeOptionOrder(panel) {
      var container = panel.querySelector('.ipvq__options');
      if (!container) return;
      var options = Array.prototype.slice.call(container.querySelectorAll('[data-ipvq-option]'));
      var notSure = options.filter(function (b) { return b.classList.contains('ipvq__option--muted'); });
      var normal = options.filter(function (b) { return !b.classList.contains('ipvq__option--muted'); });
      shuffleArray(normal);
      normal.concat(notSure).forEach(function (btn) { container.appendChild(btn); });
    }
    function bindOptions(panel) {
      var maxSelect = parseInt(panel.dataset.maxSelect, 10) || 1;
      var options = Array.prototype.slice.call(panel.querySelectorAll('[data-ipvq-option]'));
      var key = panel.dataset.ipvqPanel;
      state.answers[key] = state.answers[key] || [];
      options.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var selected = btn.classList.contains('is-selected');
          var list = state.answers[key];
          if (maxSelect === 1) {
            options.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
            list.length = 0;
            btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true'); list.push(optionPayload(btn));
          } else {
            if (selected) {
              btn.classList.remove('is-selected'); btn.setAttribute('aria-pressed', 'false');
              state.answers[key] = list.filter(function (a) { return a.el !== btn; });
            } else {
              if (list.length >= maxSelect) {
                btn.animate([{transform:'translateX(0)'},{transform:'translateX(-4px)'},{transform:'translateX(4px)'},{transform:'translateX(0)'}], {duration:220});
                return;
              }
              btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true'); list.push(optionPayload(btn));
            }
          }
          if (maxSelect > 1) {
            var atMax = state.answers[key].length >= maxSelect;
            options.forEach(function (b) { if (!b.classList.contains('is-selected')) b.classList.toggle('is-disabled', atMax); });
          }
          updateCounter(panel); updateNextState(panel);
        });
      });
    }
    function collectFlavourLabels() {
      var labels = {};
      Object.keys(state.answers).forEach(function (key) {
        state.answers[key].forEach(function (answer) {
          answer.tags.forEach(function (t) { if (CONFIG.flavourTags.indexOf(t.tag) !== -1 && !labels[t.tag]) labels[t.tag] = answer.label; });
        });
      });
      return labels;
    }
    function tagLabel(tag, dynamicLabels) { return dynamicLabels[tag] || STATIC_TAG_LABELS[tag] || (tag.charAt(0).toUpperCase() + tag.slice(1)); }
    // Order the user actually clicked flavours in (Q1 allows up to 3). Used
    // as a tie-breaker below so that whichever flavour was picked FIRST wins
    // when two or more flavours tie on score — without this, a plain score
    // sort is stable and always favours whichever tag happens to come first
    // in CONFIG.flavourTags ("fruity"), regardless of what the shopper chose.
    function flavourSelectionOrder() {
      var order = {};
      var idx = 0;
      (state.answers.q1 || []).forEach(function (answer) {
        answer.tags.forEach(function (t) {
          if (CONFIG.flavourTags.indexOf(t.tag) !== -1 && !(t.tag in order)) {
            order[t.tag] = idx++;
          }
        });
      });
      return order;
    }
    // Q1 allows up to 3 picks, and every flavour block is scored identically
    // (40 each) in the theme editor, so a flat sum meant any 2-3 picks were
    // an exact tie decided only by click order. Weighting by pick rank
    // (1st > 2nd > 3rd) reflects real preference strength and removes most
    // of those artificial ties at the source.
    var Q1_RANK_WEIGHTS = [40, 25, 15];
    function computeScores() {
      var scores = {};
      Object.keys(state.answers).forEach(function (key) {
        state.answers[key].forEach(function (answer, pickIndex) {
          answer.tags.forEach(function (t) {
            var weight = t.weight;
            if (key === 'q1' && CONFIG.flavourTags.indexOf(t.tag) !== -1 && typeof Q1_RANK_WEIGHTS[pickIndex] === 'number') {
              weight = Q1_RANK_WEIGHTS[pickIndex];
            }
            scores[t.tag] = (scores[t.tag] || 0) + weight;
          });
        });
      });
      return scores;
    }
    function topOf(list, scores) {
      var best = null;
      list.forEach(function (tag) { var s = scores[tag] || 0; if (s > 0 && (!best || s > best.score)) best = { tag: tag, score: s }; });
      return best;
    }
    function collectionFor(tag) { var data = tagData[tag]; if (data && data.available && data.products && data.products.length) return data; return null; }
    function buildRecommendation() {
      var scores = computeScores();
      var dynamicLabels = collectFlavourLabels();
      var flavourOrder = flavourSelectionOrder();
      var flavourSorted = CONFIG.flavourTags.map(function (t) {
        return { tag: t, score: scores[t] || 0, order: t in flavourOrder ? flavourOrder[t] : 999 };
      }).filter(function (t) { return t.score > 0; }).sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.order - b.order;
      });
      var primaryTag = flavourSorted[0] ? flavourSorted[0].tag : CONFIG.fallbackFlavourTag;
      var primaryCollection = collectionFor(primaryTag) || collectionFor(CONFIG.fallbackFlavourTag);
      if (!primaryCollection) {
        // Last-resort fallback when neither the scored flavour nor
        // fallbackFlavourTag has a usable collection. Pick randomly among
        // whatever tags do have one, rather than always landing on
        // whichever tag happens to be listed first (previously this always
        // resolved to "fruity" since it's first in the tag list, regardless
        // of the shopper's actual answers).
        var eligibleTags = Object.keys(tagData).filter(function (t) { return collectionFor(t); });
        var anyTag = eligibleTags.length ? eligibleTags[Math.floor(Math.random() * eligibleTags.length)] : null;
        primaryCollection = anyTag ? tagData[anyTag] : null;
        primaryTag = anyTag || primaryTag;
      }
      var secondaryFlavour = flavourSorted[1] ? flavourSorted[1].tag : null;
      var nicotineWinner = topOf(CONFIG.nicotineTags, scores);
      var nicotineTag = nicotineWinner ? nicotineWinner.tag : null;
      var beginnerScore = scores.beginner || 0;
      var coolingScore = scores.cooling || 0;
      var topFlavourScore = flavourSorted[0] ? flavourSorted[0].score : 0;
      var pct = settings.matchMin + (topFlavourScore / 120) * (settings.matchMax - settings.matchMin);
      if (nicotineTag) pct += 4;
      if (coolingScore > 0) pct += 3;
      if (scores.bestsellers || scores.newflavours || scores.premium || scores.value) pct += 3;
      pct = Math.max(settings.matchMin, Math.min(settings.matchMax, Math.round(pct)));
      var candidateTags = [];
      if (secondaryFlavour) candidateTags.push(secondaryFlavour);
      if (nicotineTag && nicotineTag !== primaryTag) candidateTags.push(nicotineTag);
      ['premium','value','beginner'].forEach(function (t) { if (scores[t]) candidateTags.push(t); });
      candidateTags.push('bestsellers', 'newflavours');
      flavourSorted.slice(2).forEach(function (f) { candidateTags.push(f.tag); });
      var seen = {}; var related = [];
      candidateTags.forEach(function (tag) {
        if (seen[tag] || tag === primaryTag) return;
        var coll = collectionFor(tag);
        if (!coll) return;
        seen[tag] = true;
        related.push({ tag: tag, data: coll });
      });
      related = related.slice(0, CONFIG.relatedCollectionsCount);
      var products = []; var productIds = {};
      function addProducts(coll) {
        if (!coll || !coll.products) return;
        coll.products.forEach(function (p) { if (products.length >= CONFIG.productsPerCard) return; if (productIds[p.id]) return; productIds[p.id] = true; products.push(p); });
      }
      addProducts(primaryCollection);
      if (secondaryFlavour) addProducts(collectionFor(secondaryFlavour));
      if (nicotineTag) addProducts(collectionFor(nicotineTag));
      addProducts(collectionFor('bestsellers'));
      var reasons = [];
      Object.keys(state.answers).forEach(function (key) {
        state.answers[key].forEach(function (answer) { if (answer.reason && reasons.indexOf(answer.reason) === -1) reasons.push(answer.reason); });
      });
      var chips = [];
      flavourSorted.slice(0, 2).forEach(function (f, i) {
        var chipPct = i === 0 ? pct : Math.max(settings.matchMin - 10, Math.round(pct * (f.score / topFlavourScore)));
        chips.push({ label: tagLabel(f.tag, dynamicLabels) + ' ' + chipPct + '%', accent: i === 0 });
      });
      if (coolingScore > 0) { var coolPct = Math.min(100, Math.round((coolingScore / 40) * 100)); chips.push({ label: 'Cooling ' + coolPct + '%' }); }
      if (beginnerScore >= settings.beginnerThreshold) chips.push({ label: 'Beginner Friendly' });
      if (nicotineTag) chips.push({ label: tagLabel(nicotineTag, dynamicLabels) });
      return { primaryTag: primaryTag, primaryCollection: primaryCollection, nicotineTag: nicotineTag, pct: pct, related: related, products: products, reasons: reasons.slice(0, 5), chips: chips, dynamicLabels: dynamicLabels };
    }
    function starString(rating) { var full = Math.round(rating); return '★★★★★'.slice(0, full) + '☆☆☆☆☆'.slice(0, 5 - full); }
    function escapeHtml(str) { var div = document.createElement('div'); div.textContent = str == null ? '' : String(str); return div.innerHTML; }
    function formatMoney(cents) {
      try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'GBP' }); }
      catch (e) { return '£' + (cents / 100).toFixed(2); }
    }
    function addToCart(variantId, btn) {
      if (!variantId) return;
      btn.disabled = true;
      var original = btn.textContent;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = settings.addedText; btn.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var bubble = document.querySelector('#cart-icon-bubble, [data-cart-count]');
          if (bubble) fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { if (bubble.dataset) bubble.textContent = cart.item_count; });
          setTimeout(function () { btn.textContent = original; btn.classList.remove('is-added'); btn.disabled = false; }, 1800);
        })
        .catch(function () { btn.textContent = original; btn.disabled = false; });
    }
    function buildProductCard(product) {
      var card = document.createElement('div'); card.className = 'ipvq__product-card';
      var imageLink = document.createElement('a'); imageLink.href = product.url; imageLink.className = 'ipvq__product-image-link';
      if (product.image) { var img = document.createElement('img'); img.src = product.image; img.alt = product.title; img.loading = 'lazy'; imageLink.appendChild(img); }
      card.appendChild(imageLink);
      var body = document.createElement('div'); body.className = 'ipvq__product-body';
      var titleLink = document.createElement('a'); titleLink.href = product.url; titleLink.className = 'ipvq__product-title'; titleLink.textContent = product.title; body.appendChild(titleLink);
      var stars = document.createElement('div'); stars.className = 'ipvq__product-stars'; stars.setAttribute('aria-hidden', 'true'); stars.textContent = starString(parseFloat(root.dataset.defaultRating || '4.8')); body.appendChild(stars);
      var price = document.createElement('div'); price.className = 'ipvq__product-price'; price.textContent = product.price_formatted || '';
      if (product.compare_at_price && product.compare_at_price > product.price) { var compare = document.createElement('span'); compare.className = 'ipvq__product-compare'; compare.textContent = formatMoney(product.compare_at_price); price.appendChild(compare); }
      body.appendChild(price);
      var addBtn = document.createElement('button'); addBtn.type = 'button'; addBtn.className = 'ipvq__product-add'; addBtn.textContent = product.available ? settings.addToCartText : settings.soldOutText;
      if (!product.available) addBtn.disabled = true;
      addBtn.addEventListener('click', function () { addToCart(product.variant_id, addBtn); });
      body.appendChild(addBtn); card.appendChild(body); return card;
    }
    function renderResults() {
      var rec = buildRecommendation();
      var dynamicLabels = rec.dynamicLabels;
      var name = rec.primaryCollection ? (rec.nicotineTag ? tagLabel(rec.primaryTag, dynamicLabels) + ' ' + tagLabel(rec.nicotineTag, dynamicLabels) : (rec.primaryCollection.title || tagLabel(rec.primaryTag, dynamicLabels))) : tagLabel(rec.primaryTag, dynamicLabels);
      var img = root.querySelector('[data-ipvq-match-image]'); var pctEl = root.querySelector('[data-ipvq-match-percent]'); var titleEl = root.querySelector('[data-ipvq-match-title]');
      var descEl = root.querySelector('[data-ipvq-match-desc]'); var ctaEl = root.querySelector('[data-ipvq-match-cta]'); var starsEl = root.querySelector('[data-ipvq-stars]');
      var priceEl = root.querySelector('[data-ipvq-match-price]');
      var url = (rec.primaryCollection && rec.primaryCollection.url) || settings.fallbackShopUrl;
      // Show an actual product from the matched collection rather than the
      // collection's own static banner image, which never changes and was
      // making every match look identical even when the underlying
      // collection had several different products in it. Use the first
      // product in the collection (its featured/primary listing), not a
      // random one — collections can contain loosely-related cross-sell
      // items (e.g. a Spearmint SKU inside "Fruity"), and picking randomly
      // risked surfacing one of those instead of something on-theme.
      var displayImage = (rec.primaryCollection && rec.primaryCollection.image) || '';
      var primaryProducts = (rec.primaryCollection && rec.primaryCollection.products) || [];
      if (primaryProducts.length && primaryProducts[0].image) {
        displayImage = primaryProducts[0].image;
      }
      if (img) { img.src = displayImage; img.alt = name; }
      if (pctEl) pctEl.textContent = rec.pct + '% Match';
      if (titleEl) titleEl.textContent = name;
      if (descEl) descEl.textContent = (rec.primaryCollection && rec.primaryCollection.description) || (name + ' flavours, matched to your answers.');
      if (starsEl) starsEl.textContent = starString(parseFloat(root.dataset.defaultRating || '4.8')) + ' (' + (root.dataset.defaultReviewCount || '128') + ')';
      if (ctaEl) { ctaEl.href = url; ctaEl.textContent = settings.shopCollectionTemplate.replace('{name}', name); }
      // Make the image + heading clickable through to the same page as the CTA button.
      root.querySelectorAll('[data-ipvq-match-href]').forEach(function (a) { a.href = url; });
      if (priceEl) {
        var lowestPrice = null;
        var productList = (rec.primaryCollection && rec.primaryCollection.products) || [];
        productList.forEach(function (p) { if (typeof p.price === 'number' && (lowestPrice === null || p.price < lowestPrice)) lowestPrice = p.price; });
        if (root.dataset.showMatchPrice === 'true' && lowestPrice !== null) {
          priceEl.textContent = (root.dataset.matchPricePrefix || 'From') + ' ' + formatMoney(lowestPrice);
          priceEl.style.display = '';
        } else {
          priceEl.textContent = '';
          priceEl.style.display = 'none';
        }
      }
      var viewAllEl = root.querySelector('[data-ipvq-view-all]'); if (viewAllEl) viewAllEl.href = url;
      var dnaWrap = root.querySelector('[data-ipvq-dna-chips]');
      if (dnaWrap) { dnaWrap.innerHTML = ''; rec.chips.forEach(function (chip) { var span = document.createElement('span'); span.className = 'ipvq__dna-chip' + (chip.accent ? ' is-accent' : ''); span.innerHTML = '<strong>' + escapeHtml(chip.label) + '</strong>'; dnaWrap.appendChild(span); }); }
      var relatedGrid = root.querySelector('[data-ipvq-related-grid]');
      if (relatedGrid) { relatedGrid.innerHTML = ''; rec.related.forEach(function (item) { var a = document.createElement('a'); a.className = 'ipvq__related-card'; a.href = item.data.url; var relIcon = STATIC_TAG_ICONS[item.tag] || '🍬'; a.innerHTML = '<span aria-hidden="true">' + relIcon + '</span><span>' + escapeHtml(item.data.title || tagLabel(item.tag, dynamicLabels)) + '</span>'; relatedGrid.appendChild(a); }); }
      var reasonsList = root.querySelector('[data-ipvq-reasons]');
      if (reasonsList) { reasonsList.innerHTML = ''; rec.reasons.forEach(function (reason) { var li = document.createElement('li'); li.textContent = reason; reasonsList.appendChild(li); }); }
      var productsGrid = root.querySelector('[data-ipvq-products-grid]');
      if (productsGrid) { productsGrid.innerHTML = ''; rec.products.forEach(function (product) { productsGrid.appendChild(buildProductCard(product)); }); }
      announce('Your results are ready: ' + name + ', ' + rec.pct + '% match.');
    }
    function runAnalysing() {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-ipvq-loading-item]'));
      var fill = root.querySelector('[data-ipvq-analysing-fill]');
      items.forEach(function (item) { item.classList.remove('is-active', 'is-done'); });
      if (!items.length) { finishAnalysing(); return; }
      var perItem = settings.loadingDuration / items.length;
      var i = 0;
      function step() {
        if (i > 0) items[i - 1].classList.remove('is-active');
        if (i > 0) items[i - 1].classList.add('is-done');
        if (i >= items.length) { finishAnalysing(); return; }
        items[i].classList.add('is-active');
        if (fill) fill.style.width = Math.round(((i + 1) / items.length) * 100) + '%';
        i += 1;
        window.setTimeout(step, perItem);
      }
      step();
    }
    function finishAnalysing() { renderResults(); showPanel('results'); announce('Results ready'); }
    function resetQuiz() {
      Object.keys(state.answers).forEach(function (key) { state.answers[key] = []; });
      root.querySelectorAll('[data-ipvq-option]').forEach(function (btn) { btn.classList.remove('is-selected', 'is-disabled'); btn.setAttribute('aria-pressed', 'false'); });
      root.querySelectorAll('[data-ipvq-counter]').forEach(function (c) { c.textContent = ''; });
      root.querySelectorAll('[data-ipvq-next]').forEach(function (b) { b.disabled = true; });
      // Options are only shuffled once, at initial page load. "Retake Quiz"
      // doesn't reload the page, so without this the option order looked
      // frozen across repeated retakes in the same session.
      questionPanels.forEach(function (panel) {
        if ((parseInt(panel.dataset.maxSelect, 10) || 1) > 1) randomizeOptionOrder(panel);
      });
      goToStep(-1);
    }
    var startBtn = root.querySelector('[data-ipvq-start]');
    if (startBtn) startBtn.addEventListener('click', function () { goToStep(0); });
    questionPanels.forEach(function (panel, idx) {
      if ((parseInt(panel.dataset.maxSelect, 10) || 1) > 1) randomizeOptionOrder(panel);
      bindOptions(panel); updateCounter(panel);
      var nextBtn = panel.querySelector('[data-ipvq-next]');
      if (nextBtn) nextBtn.addEventListener('click', function () { if (idx === totalQuestions - 1) { goToStep('analysing'); } else { goToStep(idx + 1); } });
      var backBtn = panel.querySelector('[data-ipvq-back]');
      if (backBtn) backBtn.addEventListener('click', function () { if (idx === 0) goToStep(-1); else goToStep(idx - 1); });
    });
    root.querySelectorAll('[data-ipvq-retake], [data-ipvq-retake-inline]').forEach(function (btn) { btn.addEventListener('click', resetQuiz); });
    root.__ipvqGoToStep = goToStep;
    root.__ipvqTotalQuestions = totalQuestions;

    showPanel('welcome', { silent: true });
  }
  function bootstrap(scope) { (scope || document).querySelectorAll('[data-ipvq]').forEach(initQuiz); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { bootstrap(document); }); } else { bootstrap(document); }
  document.addEventListener('shopify:section:load', function (evt) { bootstrap(evt.target); });
  document.addEventListener('shopify:block:select', function (evt) {
    var root = evt.target.closest('[data-ipvq]');
    if (!root) return;
    var panel = evt.target.closest('[data-ipvq-panel]');
    if (!panel || typeof root.__ipvqGoToStep !== 'function') return;
    var name = panel.dataset.ipvqPanel;
    if (name === 'welcome') root.__ipvqGoToStep(-1);
    else if (/^q\d$/.test(name)) root.__ipvqGoToStep(parseInt(name.replace('q', ''), 10) - 1);
    else if (name === 'analysing') root.__ipvqGoToStep(-1);
    else if (name === 'results') root.__ipvqGoToStep(-1);
  });
})();
